import React, { FC } from 'react';
import DatePicker, { DatePickerProps } from 'react-date-picker';
import { useTranslation } from 'react-i18next';

import { Calendar } from '../../assets';

import './input.scss';
import './DateInput.scss';

interface Props extends DatePickerProps {
  label?: string;
  isValid?: boolean;
}

const DateInput: FC<Props> = ({ label, isValid = true, disabled = false, ...rest }) => {
  const { t } = useTranslation();

  return (
    <div className={`input-container date-input ${!isValid ? 'input-invalid' : ''}`}>
      <p className={disabled ? 'disabled' : ''}>{t(label)}</p>
      <DatePicker {...rest} format='dd/MM/y' calendarIcon={<Calendar />} />
    </div>
  );
};

export default DateInput;
